<template>
    <div class="answer__image relative"
         :class="{'answer__image--correct': isCorrect, 'answer__image--incorrect': isIncorrect}">
        <div class="overlay">
            <Check class="check" />
            <Times class="times" />
        </div>
        <img :src="src">
    </div>
</template>

<script>
import Check from "./Vector/Check.vue";
import Times from "./Vector/Times.vue";

export default {
	name: "AnswerImage",
	components: {Times, Check},
	props: {
		src: {
			type: String,
			default: "/img/answer_image.png"
		},
		answer: Object,
		selectedAnswer: Boolean,
	},
	computed: {
		isCorrect() {
			return this.selectedAnswer && this.answer.is_correct;
		},
		isIncorrect() {
			return this.selectedAnswer && !this.answer.is_correct;
		},
	}
};
</script>

<style scoped lang="scss">
.answer__image {
    height: 100%;
    aspect-ratio: 1;
    flex: 0 1 auto;
    --border-radius: 10px 0px 0px 10px;
    --border-width: 2px;
    --scale-initial: 2;
    --scale-final: 1;

    @media (min-width: 1024px) {
        --border-radius: 20px 0px 0px 20px;
        --border-width: 4px;
        --scale-initial: 2.5;
        --scale-final: 1.5;
    }

    img {
        border-radius: var(--border-radius);
        border-right: var(--border-width) solid black;
        height: 100%;
    }
    .overlay {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: var(--border-radius);
        border-right: var(--border-width) solid black;

        .times,
        .check {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: scale(var(--scale-initial)) translate(-50%, -50%);
            opacity: 0;
            transition: transform .4s cubic-bezier(.47,1.64,.41,.8), opacity .4s cubic-bezier(.47,1.64,.41,.8);
        }
    }

    &.answer__image--correct,
    &.answer__image--incorrect {
        .overlay {
            opacity: 1;
        }
    }

    &.answer__image--correct .overlay {
        background: linear-gradient(0deg, rgba(66, 200, 173, 0.7), rgba(66, 200, 173, 0.7));
        .check {
            opacity: 1;
            transform:  translate(-50%, -50%) scale(var(--scale-final));
        }
    }
    &.answer__image--incorrect .overlay {
        background: linear-gradient(0deg, rgba(213, 60, 89, 0.7), rgba(213, 60, 89, 0.7));
        .times {
            opacity: 1;
            transform:  translate(-50%, -50%) scale(var(--scale-final));
        }
    }
}
</style>
